import { Module } from 'vuex';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { serializer } from '@/api/shared/serializer';
import moment from 'moment';
import { CallsTypes } from '@/enums/CallsTypes';

const callsModule: Module<any, any> = {
  namespaced: false,
  state: {
    calls: [],
    currentCall: null,
  },
  mutations: {
    setCurrentCall(state, data) {
      state.currentCall = data;
    },
    setCalls(state, data) {
      state.calls = data;
    },
    setFamilyHubMemberScheduledCalls(state, data) {
      state.familyHubMemberScheduledCalls = data;
    },
  },
  actions: {
    async getCalls({ commit }) {
      return await firebase
        .firestore()
        .collection('calls')
        .where('facilityId', '==', this.state.authModule.currentFacility)
        .get()
        .then(querySnapshot => {
          const calls = serializer.querySnapshotToDocuments(querySnapshot);
          commit('setCalls', calls);
        });
    },

    async getCallById({ commit }, id) {
      await firebase
        .firestore()
        .collection('calls')
        .doc(id)
        .get()
        .then(doc => {
          const call: any = serializer.documentSnapshotToDocument(doc);
          if (call.scheduledAt) {
            call.scheduledAt = moment(call.scheduledAt.seconds * 1000).toDate();
          }
          if (call.start) {
            call.start = moment(call.start.seconds * 1000).toDate();
          }
          if (call.end) {
            call.end = moment(call.end.seconds * 1000).toDate();
          }
          commit('setCurrentCall', call);
        });
    },

    async getScheduledCallsByFamilyHubMemberId({ commit }, familyHubMemberId) {

      const fromDate = moment().add(-1, 'months').toDate();

      const calenderEvents = firebase
        .firestore()
        .collection('calls')
        .where('facilityId', '==', this.state.authModule.currentFacility)
        .where('callType', '==', CallsTypes.ScheduledCall)
        .where('participantIds', 'array-contains', familyHubMemberId)
        .where('scheduledAt', '>=', fromDate);

      await calenderEvents.get().then(querySnapshot => {
        const resList: Array<any> = [];
        querySnapshot.docs.forEach(x => {
          const thisRes = x.data();
          thisRes.id = x.id;
          resList.push(thisRes);
        });
        
        commit('setFamilyHubMemberScheduledCalls', resList);
      });
    },

    async updateCall({ commit, dispatch }, { id, data }) {
      await firebase
        .firestore()
        .collection('calls')
        .doc(id)
        .update(data)
        .then(() => {
          dispatch('getCallById', id);
        });
    },

    async deleteCall({ commit, state, rootState }, callId) {
      await firebase
        .firestore()
        .collection('calls')
        .doc(callId)
        .delete()
        .then(() => {
          const calendarEvents = rootState.calenderModule.calenderEvents || [];
          const updatedEvents = calendarEvents.filter(
            event => event.id !== callId
          );
          commit('setCalenderEvents', updatedEvents, { root: true });
        });
    },
  },
};

export default callsModule;
